import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/Auth/Login";
import Signup from "../pages/ClientSpace/Signup/Signup";
import ClientSpace from "../pages/ClientSpace/ClientSpace";
import AdminSpace from "../pages/AdminSpace/AdminSpace";
import AdminNetworkSpace from "../pages/AdminNetworkSpace/AdminNetworkSpace";
import InstructSpace from "../pages/InstructSpace/InstructSpace";
import SynerpaSpace from "../pages/SynerpaSpace/SynerpaSpace";
import SuccessSignup from "../pages/ClientSpace/Signup/SuccessSignup";
import Element from "./Element";
import ProtectedRoute from "./ProtectedRoute";
import { useAuth } from "../hooks";
import { RolesEnum } from "../types";
import ChangePassword from "../pages/Auth/ChangePassword";
import LoaderFC from "../components/UIElements/LoaderFC";
import { RoutesEnum } from "./routes";
import PageNotFound from "../pages/PageNotFound";
import AdminRegionSpace from "../pages/AdminRegionSpace/AdminRegionSpace";

export default function CustomRouter() {
    const { getConnectedUser } = useAuth();

    const getSpaceByUserRole = () => {
        const connectedUser = getConnectedUser();
        if (connectedUser) {
            const userRole = connectedUser.currentUserRoleId;
            switch (userRole) {
                case RolesEnum.CLIENT:
                    return <ClientSpace />;
                case RolesEnum.ADMIN:
                    return <AdminSpace />;
                case RolesEnum.INSTRUCTEUR:
                    return <InstructSpace />;
                case RolesEnum.SYNERPA:
                    return <SynerpaSpace />;
                case RolesEnum.ADMIN_RESEAU:
                    return <AdminNetworkSpace />;
                case RolesEnum.ADMIN_REGION:
                    return <AdminRegionSpace />;
                default:
                    return <></>;
            }
        }
        return <></>;
    };

    return (
        <BrowserRouter>
            <Routes>
                <Route path={RoutesEnum.login} element={<Login />} />
                <Route
                    path={RoutesEnum.signup}
                    element={
                        <>
                            <Signup /> <LoaderFC />
                        </>
                    }
                />
                <Route
                    path={RoutesEnum.successSignup}
                    element={<Element page={<SuccessSignup />} />}
                />
                <Route
                    path="/"
                    element={<Navigate to={RoutesEnum.login} replace />}
                />
                <Route
                    caseSensitive
                    path={RoutesEnum.monespace}
                    element={
                        <ProtectedRoute>
                            <Element page={getSpaceByUserRole()} />
                            <LoaderFC />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={RoutesEnum.resetpassword}
                    element={<ChangePassword />}
                />
                {/* 👇️ only match this when no other routes match */}
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    );
}
